module.exports = __webpack_public_path__ + "img/google-play-badge-da.92a6780d.png";